module.exports = __webpack_public_path__ + "img/close_modal_16px.0e8fc776.svg";